import React from 'react';
import Div from '../../common/components/div';
import translate from '../../common/functions/translate';
import { usePageViewWithSteps } from '../../common/hooks/use.analytics';
import { usePageTitle } from '../../common/hooks/use.page.title';
import use from '../../common/objects/use';
import YourAccountDetails from './your.account.details';
import YourBasicInformation from './your.basic.information';
import YourMedicareInformation from './your.medicare.information';

export default function CreateAccount() {
   const data = use.createAccountData;
   
   usePageTitle(translate('Create an account'));

   const getStep = () => {
      switch (data.step.get()) {
         case 1:
            return <YourMedicareInformation/>;
         case 2:
            return <YourBasicInformation/>;
         case 3:
            return <YourAccountDetails/>;
         default:
            return <YourMedicareInformation/>;
      }
   };

   const getStepTitle = () => {
      switch (data.step.get()) {
         case 1:
            return 'Your Medicare information';
         case 2:
            return 'Your basic information';
         case 3:
            return 'Your account details';
         default:
            return 'Your Medicare information';
      }
   };
   
   usePageViewWithSteps('Create an account', data.step.get(), getStepTitle());
   
   return <>
      <Div
         isContainer={true}
         paddingySM={1} paddingyMD={2} paddingyLG={3} paddingyXL={4}
      >
         {getStep()}
      </Div>
   </>;
}